<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Prepaid Fiber Customer
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 50, 100, 250, -1],
            }"
          >

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <!-- <template v-slot:[`item.name`]="{ item }">
        <a @click="viewDrawDetail(item)">{{ item.name }}</a>
      </template> -->

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                x-small
                color="warning"
                class="mr-2"
                dark
                @click="changeNap(item)"
              >
                Change NAP</v-btn
              >

              <v-btn
                x-small
                color="pink"
                v-if="
                  item.status != 'ACTIVATED' &&
                    item.status != 'RELEASED' &&
                    item.status != 'DELETED'
                "
                dark
                @click="cancelCustomer(item)"
              >
                Cancel</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <ConfirmationDiaglog
      :dialog="confimationDialog.dialog"
      :message="confimationDialog.message"
      :title="confimationDialog.title"
      @response="confimationDialogResponse"
    ></ConfirmationDiaglog>
    <Snackbar></Snackbar>
    <ApproveJoDialog
      :dialog="approvedDialog.dialog"
      @response="approveJoDialogResponse"
    ></ApproveJoDialog>

    <ChangeNapDialog ref="changeNapDialog" />
    <CancelAquisition ref="cancelAquisition" />
  </v-container>
</template>

<script>
import moment from "moment";
import ConfirmationDiaglog from "../dialogs/ConfirmationDiaglog.vue";
import Snackbar from "../dialogs/Snackbar.vue";
import ApproveJoDialog from "../dialogs/acquisition/ApproveJoDialog.vue";
import ChangeNapDialog from "../dialogs/acquisition/ChangeNapDialog.vue";
import CancelAquisition from "../dialogs/acquisition/CancelAquisition.vue";
export default {
  components: {
    ConfirmationDiaglog,
    Snackbar,
    ApproveJoDialog,
    ChangeNapDialog,
    CancelAquisition,
  },
  data() {
    return {
      exportData: [],
      fileName: "",

      confimationDialog: {
        dialog: false,
        message: "",
        title: "",
      },

      approvedDialog: {
        dialog: false,
      },
      selectedJO: {},
      search: "",
      paths: {
        viewInfo: "/draw/view",
      },
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        // sortBy: "dtCreated",
        // sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Created Date",
            align: "start",
            sortable: true,
            value: "createdDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
          // firstName, lastName, city, address
          {
            text: "Referrence Number",
            align: "start",
            value: "referenceNumber",
          },
          {
            text: "First name",
            align: "start",
            value: "firstName",
          },
          {
            text: "Last name",
            align: "start",
            value: "lastName",
          },

          {
            text: "City",
            align: "start",
            value: "city",
          },
          
          {
            text: "Province",
            align: "start",
            value: "province",
          },

          {
            text: "NAP Code",
            align: "start",
            value: "napCode",
            sortable: false,
          },
          {
            text: "Port",
            align: "start",
            value: "port",
            sortable: true,
          },
          {
            text: "Retailer Name",
            align: "start",
            value: "retailerName",
            sortable: false,
          },
          {
            text: "Status",
            align: "start",
            value: "status",

            sortable: true,
          },
          {
            text: "Actions",
            align: "center",
            value: "actions",
            sortable: false,
            width: "200px",
          },
        ],
        data: [],
      },
      options: {
        page: 1,
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList(status = "", searchVal = "") {
      this.table.loading = true;

      const { page, itemsPerPage } = this.options;
      let pageNumber = page ? page : 1;
      // console.log(status);

      // console.log(pageNumber, itemsPerPage);

      await this.$api
        .get(
          `dashboard/prepaid-fiber-customer?status=${status}&page=${pageNumber}&limit=${itemsPerPage}&searchVal=${searchVal}`
        )
        .then((response) => {
          // console.log(response);
          const newArr = response.data.data;
          this.table.data = newArr.prepaidFiberCustomers;

          this.table.total = newArr.total;
          this.table.numberOfPages = Math.ceil(newArr.total / itemsPerPage);
          let exportData = newArr.prepaidFiberCustomers.map((item) => {
            return {
              "Application Date": moment(item.createdDate).format(
                "MMM DD, YYYY"
              ),
              "Area Name": item.area,
              Section: "",
              City: item.city,
              "JO Number": item.account ? "'" + item.account.jo_no : "",
              "Activation Date": moment(item.activationDate).format(
                "MMM DD, YYYY"
              ),
              Status: item.status,
              "First Name": item.firstName,
              "Last Name": item.lastName,
              "Date of Birth": moment(item.birthdate).format("MMM DD, YYYY"),
              "Mobile Number": item.mobileNumber,
              "Email Address": item.emailAddress,
              Address: item.address,
              "Map Coordinates": `${item.lat ? item.lat : ""}${
                item.long ? ", " + item.long : ""
              }`,
              "Suggested NAP (Complete NAP Code)": "",
              "NAP Used": item.napCode,
              "Port Used": item.port,
              "Territory Head": "",
              "Retailer Name": item.retailerName ? item.retailerName : "",
              "Dealer Name": item.dealerName,
              "Payment Date": item.paymentDate,
              "ONU Serial Number": item.onuSerial,
            };
          });
          this.fileName = "prepaid_fiber_customer";
          this.exportData = exportData;

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async approved(data) {
      console.log(data);
      this.selectedJO = data;
      this.approvedDialog.dialog = true;
    },

    async reject(data) {
      this.confimationDialog.title = "Reject";
      this.confimationDialog.message =
        "Are you sure you want to reject this JO?";
      this.confimationDialog.dialog = true;
      this.selectedJO = data;
      // console.log(data);
    },

    async doReject() {
      // this.table.loading = true;
      await this.$api
        .delete("/dashboard/jo-approver", {
          data: { _id: this.selectedJO._id },
        })
        .then((response) => {
          // console.log(response.data);
          const res = response.data;
          // console.log(newArr);
          if (!res.status) {
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            return;
          }
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.confimationDialog.dialog = false;
          this.getList();
          // this.table.data = newArr.subscribers;
          // this.table.loading = false;
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
    },

    confimationDialogResponse(response) {
      // console.log(response);
      if (!response) {
        this.confimationDialog.dialog = false;
        return;
      }

      this.doReject();
    },

    approveJoDialogResponse(response) {
      if (!response) {
        this.approvedDialog.dialog = false;
        return;
      }

      const _id = this.selectedJO._id;
      let data = { ...response, _id };
      // console.log(data);
      this.doApproved(data);
    },

    async doApproved(data) {
      console.log(data);
      await this.$api
        .post("/dashboard/jo-approver", data)
        .then((response) => {
          const res = response.data;
          // console.log(newArr);
          if (!res.status) {
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            return;
          }
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.approvedDialog.dialog = false;
          this.getList();
          // this.table.data = newArr.subscribers;
          // this.table.loading = false;
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
    },

    searchRecord() {
      if (!this.search) {
        return;
      }

      this.getList("", this.search);
    },

    async changeNap(data) {
      await this.$refs.changeNapDialog.open(data);
    },

    async cancelCustomer(data) {
      await this.$refs.cancelAquisition.open(data);
    },
  },
  created() {
    // console.log(this.$props.headers);
  },

  mounted() {
    this.getList();
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },

    options: {
      handler() {
        this.getList("", this.search);
      },
      deep: true,
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
